/**
 * @Author: hongwei
 * @Date: 2021-12-08 19:13:16.428
 * @Last Modified by: xinzhong
 * @Last Modified time: 2026-02-11 20:22:34
 */

export default {
    name: 'YqgFooter',

    methods: {
        jumpTo(url) {
            window.location.href = url;
        }
    }
};
